exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "quill-editor {\n  display: block;\n}\n\n.ql-snow .ql-editor h1 {\n  font-size: 2.5rem !important;\n}\n\n.ql-snow .ql-editor h2 {\n  font-size: 2rem !important;\n}\n\n.ql-snow .ql-editor h3 {\n  font-size: 1.75rem !important;\n}\n\n.ql-snow .ql-editor h4 {\n  font-size: 1.5rem !important;\n}\n\n.ql-snow .ql-editor h5 {\n  font-size: 1.25rem !important;\n}\n\n.ql-snow .ql-editor h6 {\n  font-size: 1rem !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/snowriders/app/src/app/ngx-quill-editor/quill-editor.component.css
// module id = ../../../../../src/app/ngx-quill-editor/quill-editor.component.css
// module chunks = main